<script setup>
const props = defineProps({
  notInterested: {
    type: Boolean,
    default: false,
  },
  targetId: {
    type: Number,
    required: true,
  },
  targetType: {
    type: String,
    required: true,
  },
  text: {
    type: String,
    required: false,
    default: '',
  },
  theme: {
    type: String,
    required: false,
    default: 'primary',
  },
  initiatorVacancyId: {
    type: Number,
    default: null,
    required: false,
  },
})

const emit = defineEmits(['refresh'])

const apiInteraction = useApiInteraction()

const text = computed(() => {
  if (props.text !== '') return props.text
  if (props.notInterested) return 'Niet interessant'
  return 'Afwijzen'
})

async function submit() {
  await apiInteraction.createInteraction({
    targetId: props.targetId,
    targetType: props.targetType,
    type: 'denied',
    ...(props.initiatorVacancyId
      ? {
          initiatorType: 'vacancy',
          initiatorId: props.initiatorVacancyId,
        }
      : {}),
  })

  emit('refresh')
}
</script>

<template>
  <Button :theme :text size="sm" @click="submit" />
</template>
